import { styled } from "@mui/material/styles";
import { Button as MuiButton } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const StyledButton = styled(MuiButton)(({ theme, size = "medium" }) => ({
  borderRadius: theme.shape.borderRadius,
  textTransform: "none",
  fontWeight: 500,
  boxShadow: "none",
  minWidth: 100,
  transition: "all 0.2s ease",
  position: "relative",
  overflow: "hidden",

  ...(size === "small" && {
    height: 32,
    fontSize: "13px",
    padding: "0 16px",
    "& .MuiSvgIcon-root": {
      fontSize: "18px",
    },
  }),

  ...(size === "medium" && {
    height: 40,
    fontSize: "14px",
    padding: "0 20px",
    "& .MuiSvgIcon-root": {
      fontSize: "20px",
    },
  }),

  "&:hover": {
    boxShadow: "none",
  },

  "&.MuiButton-contained": {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.typography[100],
    "&:hover": {
      backgroundColor: alpha(theme.palette.secondary.main, 0.9),
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.12)",
    },
    "&:active": {
      backgroundColor: theme.palette.secondary.dark,
      transform: "translateY(0)",
      boxShadow: "none",
    },
  },

  "&.MuiButton-outlined": {
    borderColor:
      theme.palette.mode === "dark"
        ? theme.palette.grey[700]
        : theme.palette.grey[300],
    color:
      theme.palette.mode === "dark"
        ? theme.palette.grey[100]
        : theme.palette.text.primary,
    borderWidth: "1.5px",
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.grey[800], 0.6)
          : alpha(theme.palette.grey[100], 0.8),
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.grey[600]
          : theme.palette.grey[400],
    },
  },

  "&.MuiButton-text": {
    color:
      theme.palette.mode === "dark"
        ? theme.palette.secondary.main
        : theme.palette.primary.main,
    padding: "0 12px",
    "&:hover": {
      backgroundColor: alpha(
        theme.palette.mode === "dark"
          ? theme.palette.secondary.main
          : theme.palette.primary.main,
        0.08
      ),
    },
  },

  "&.MuiButton-loading": {
    opacity: 0.8,
    pointerEvents: "none",
  },

  "&.Mui-disabled": {
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.grey[900], 0.8)
        : theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
    opacity: 0.6,
  },

  "& .MuiButton-startIcon": {
    marginRight: 8,
  },
  "& .MuiButton-endIcon": {
    marginLeft: 8,
  },
}));
